BaseHandler   = App.loadClass "core::reports/BaseHandler"
DetailOutput  = App.loadClass "core::reports/DetailOutput"
LoadingHandler = App.loadClass "core::FullPageLoadingHandler"

class exports.Keyfields_SubHandler extends BaseHandler
    init: (modalInstance) ->
        @modalInstance = modalInstance
        @layoutUrl          = 'backend/portal/keyfields/load-layout'
        @filterUrl          = 'backend/portal/keyfields/filters'
        @layoutSelector     = '#keyfields_container'
        @refreshNavHandler  = false

        @parent.topBuffer = () ->
            return parseInt(App.sidebar.element.outerHeight()) - 55


        @oldMaxZoom = App.map.options.maxZoom
        App.map.options.maxZoom = 17

        @maxZoom    = 12
        @group_len  = 100

        #will need to change
        @availableStatus = {
            "Not Key": "#dddddd"
            "Not Started": "#BE4948"
            "Incomplete": "#F89406"
            "Complete": "#3A894C"
        }

        @icons = {}

        @generateMarkerIcons()

        opt =
            "status":
                opt1:
                    key: "Incomplete"
                    value: "Incomplete"
                opt2:
                    key: "Not Started"
                    value: "Not Started"
                opt3:
                    key: "Complete"
                    value: "Complete"

        @loader?.destroy()
        @loader = @createSubHandler LoadingHandler
        if @loader
            @loader.init("Loading Key Fields...")

        @setDefaultsAndRun(0, 0, 0, opt)


    ###
    #
    # Initialize marker icons. These are the pushpins that represent
    # an order on the map, and they are colorcoded by order stage.
    ###
    generateMarkerIcons: () ->
        for status, color of @availableStatus
            @icons[status] =  new L.mapbox.marker.icon {
                "marker-size": "large"
                "marker-color": color
                "marker-symbol": "farm"
            }


    afterLoadLayout: (sel, data) ->
        self = this
        @year = data.data.year
        @fieldlist = []
        @fieldsOnMap = []

        # leaflet has no way of getting a marker that already exists
        # this will allow us to loop through all key field markers
        # instead of all markers.
        @keyFieldMarkers = {}

        for id, fid of data.data.fields
            @fieldlist.push(id)
            @fieldsOnMap.push(parseInt id)

        if @_post?
            @_post.abort()

        if @_timer?
            clearTimeout @_timer

        # Remove all existing event listeners
        $("#map_canvas").undelegate()

        # Add event listeners
        @EventGetDirections()
        @EventAddStandCount()
        @EventAddErl()
        @EventFindClosestKey()

        # Clear All Layers
        App.layer_store.empty()

        # Initialize the clusterer
        @markerLayer = new L.MfMarkerClusterGroup
            iconCreateFunction: @createClusterIcon,
            zoomToBoundsOnClick: true

        # Initialize boundaries layer
        @boundaryLayer = new L.FeatureGroup()

        App.layer_store.store "marker_cluster", @markerLayer
        App.layer_store.store "fields_layer", @boundaryLayer

        App.map.on 'zoomend', @updateBoundaries

        # silly test to ensure there are bounds
        if data.data.fields.length > 0
            App.map.fitBounds([
                [data.data.bounds.south, data.data.bounds.west],
                [data.data.bounds.north, data.data.bounds.east]
            ])

        @fetchField()

        if Array.isArray(@year) and not @year.length
            @loader?.destroy()
            @loader = @createSubHandler LoadingHandler
            if @loader
                @loader.init 'You must select at least one year in order to run this tool'


    ###
    Event listener to get directions
    ###
    EventGetDirections: () ->
        $("#map_canvas").delegate '.get-directions-form', 'submit', (e) ->
            e.preventDefault()
            form = $("#map_canvas").find('.get-directions-form').serialize()
            window.open "http://maps.google.com/maps?#{form}&hl=en"


    ###
    Event listener to add stand count record
    ###
    EventAddStandCount: () ->
        self = this
        $("#map_canvas").delegate '.add-sc', 'click', (e) =>
            field_id = $(e.currentTarget).closest('div').siblings('[name="fields_id"]').val()

            @modalInstance.openStandCountDialog(field_id, @year, 0).modalRef.result.then((response) =>
                @updatePopupAndMarker(e.currentTarget, field_id, '.add-sc')
            )

    ###
    Event listener to add ear, row, length record
    ###
    EventAddErl: () ->
        self = this
        $("#map_canvas").delegate '.add-erl', 'click', (e) =>
            field_id = $(e.currentTarget).closest('div').siblings('[name="fields_id"]').val()

            @modalInstance.openERLDialog(field_id, @year, 'Add').modalRef.result.then((response) =>
                @updatePopupAndMarker(e.currentTarget, field_id, '.add-erl')
            )

    ###
    Event listener to find closest point
    ###
    EventFindClosestKey: () ->
        self = this
        $("#map_canvas").delegate '.closest-point', 'click', (e) ->

            $(e.currentTarget).attr('disabled', 'disabled')
            $(e.currentTarget).find('span').html('Searching for key field...')

            field_id = $(e.currentTarget).closest('div').siblings('[name="fields_id"]').val()
            postParams = { ids: ko.toJSON(field_id), years: ko.toJSON(self.year), getClosestKey: true }

            $.post 'backend/portal/keyfields/field-info', postParams, (response) ->
                if response.data?
                    field = response.data[0].field

                    # if field is not already in report add it
                    if (self.fieldsOnMap.indexOf field.id) is -1
                        self.addFields(response.data)
                        self.fieldsOnMap.push field.id

                    # gross! leaflet has no way of fetching a marker
                    # we have to loop through all key field markers
                    # and compare ids
                    for fid, obj of self.keyFieldMarkers
                        if (parseInt field.id) is (parseInt fid)
                            # b/c ajax...
                            setTimeout () ->
                                obj.marker.openPopup()
                            , 500
                            break

                    App.map.fitBounds([
                        [field.south, field.west],
                        [field.north, field.east]
                    ])

                    self.updateBoundaries()

                    $(e.currentTarget).find('span').html('Closest Key Point')
                    $(e.currentTarget).removeAttr('disabled')

                else
                    $(e.currentTarget).find('span').html('No key fields found')

    ###
    Update the marker and popup after a form (Stand Count or ERL) is completed
    ###
    updatePopupAndMarker: (currentTarget, field_id, buttonClass) ->
        self = this

        btn = $("#map_canvas").find(currentTarget)
        td = btn.closest('td')
        tbody = btn.closest('tbody')
        if btn.hasClass('first')
            $(td).next().find(buttonClass).first().removeAttr('disabled')
        else
            btn.closest('tr').next().find(buttonClass).first().removeAttr('disabled')
        $(td).html('Complete')

        # Update the original marker with the now updated popup content
        view = $(td).closest('.leaflet-popup-content').html()

        for fid, obj of self.keyFieldMarkers
            if (parseInt field_id) is (parseInt fid)
                # determine new status
                if tbody.find('button').length > 0
                    status = 'Incomplete'
                else
                    status = 'Complete'

                # create new marker
                statusIcon = self.icons[status]
                marker = L.marker(obj.marker._latlng, { icon: statusIcon })

                # bind new popup to marker and field
                marker.bindPopup(view, { maxWidth: 400 })
                obj.field.bindPopup(view, { maxWidth: 400 })

                # remove old marker and add new marker
                self.markerLayer.removeLayer obj.marker
                self.markerLayer.addLayer marker
                obj.marker = marker

                # re-open the marker popup
                obj.marker.openPopup()

                break

    ###
    Fetch fields and add them to the map
    ###
    fetchField: () ->
        self = this

        ids         = @fieldlist[0..(@group_len - 1)]
        @fieldlist  = @fieldlist[(@group_len)..]

        if ids.length is 0
            @loader.destroy()
            return null

        postParams = { years: ko.toJSON(@year), ids: ko.toJSON(ids) }

        # From year and field ids grab field boundaries and popups
        @_post = $.post 'backend/portal/keyfields/field-info', postParams, (response) ->
            if self._destroyed then return
            markers = []

            # add Fields to map
            self.addFields(response.data)

            # Zoom map to fit fields
            App.map.fitBounds App.layer_store.getBounds()
            self.updateBoundaries()

            self._timer = setTimeout () ->
                self.fetchField()
            , 0

    ###
    Add given field data to map
    ###
    addFields: (fieldData) ->
        self = this

        for data in fieldData
            if data.field.mid_lat? and data.field.mid_lng?
                fld = L.geoJson $.parseJSON(data.field.json),
                    style: () ->
                        return {
                            color: "#00FF00",
                            opacity: 1,
                            weight: 2,
                            fillColor: "#00FF00",
                            fillOpacity: 0.1
                        }

                statusIcon = self.icons[data.field.status]
                mk = L.marker([data.field.mid_lat, data.field.mid_lng], { icon: statusIcon })

                if data.popup?
                    mk.bindPopup(data.popup, { maxWidth: 400 })
                    fld.bindPopup(data.popup, { maxWidth: 400 })

                mk.on 'click', (e) ->
                    if App.map.getZoom() <= self.maxZoom
                        App.map.setView e.latlng, 16
                    else
                        # do popup ... things
                        return

                if data.field.status isnt "Not Key"
                    self.keyFieldMarkers[data.field.id] = { 'marker': mk, 'field': fld }

                self.boundaryLayer.addLayer fld
                self.markerLayer.addLayer mk


    createViewDialog: (field_id, operators_id, btn, btnClass, layerName, saveUrl, row = null) ->
        self = this
        handler = @createSubHandler layerName

        if handler
            opts =
                year: @year
                fields_id: field_id
                users_id: operators_id

            handler.loadLayoutPostOptions = opts
            handler.sidebar_row = row
            handler.startEditing = (true)
            handler.refreshNavHandler = false
            handler.btnTarget = btn
            handler.btnClass = btnClass
            handler.saveUrl = saveUrl

            handler.afterHidden = () ->
                handler.destroy()

            handler.successAction = () ->
                # Fetch full popup view
                btn = $("#map_canvas").find(handler.btnTarget)
                td = btn.closest('td')
                tbody = btn.closest('tbody')
                if btn.hasClass('first')
                    $(td).next().find(handler.btnClass).first().removeAttr('disabled')
                else
                    btn.closest('tr').next().find(handler.btnClass).first().removeAttr('disabled')
                $(td).html('Complete')

                # Update the original marker with the now updated popup content
                view = $(td).closest('.leaflet-popup-content').html()

                for fid, obj of self.keyFieldMarkers
                    if (parseInt field_id) is (parseInt fid)
                        # determine new status
                        if tbody.find('button').length > 0
                            status = 'Incomplete'
                        else
                            status = 'Complete'

                        # create new marker
                        statusIcon = self.icons[status]
                        marker = L.marker(obj.marker._latlng, { icon: statusIcon })

                        # bind new popup to marker and field
                        marker.bindPopup(view, { maxWidth: 400 })
                        obj.field.bindPopup(view, { maxWidth: 400 })

                        # remove old marker and add new marker
                        self.markerLayer.removeLayer obj.marker
                        self.markerLayer.addLayer marker
                        obj.marker = marker

                        # re-open the marker popup
                        obj.marker.openPopup()

                        break

            handler.init()


    createClusterIcon: (cluster) =>

        childCount = cluster.getChildCount()

        c = ' marker-cluster-'
        if (childCount < 10)
            c += 'small'
        else if (childCount < 100)
            c += 'medium'
        else
            c += 'large'

        return new L.DivIcon({
            html: '
                <div class="hex-outer">
                    <div class="hex-left"></div>
                    <div class="hex-middle"></div>
                    <div class="hex-right"></div>
                </div>
                <div class="hex-inner">
                    <div class="hex-left"></div>
                    <div class="hex-middle"></div>
                    <div class="hex-right"></div>
                </div>
                <div class="count-text">
                    ' + childCount + '
                </div>
            ',
            className: 'marker-cluster' + c + ' key-fields-marker-cluster-color'
            iconSize: new L.Point(44, 44)
        })


    updateBoundaries: () =>
        if App.map.getZoom() > @maxZoom
            #show all boundaries
            App.map.addLayer @boundaryLayer
        else
            App.map.removeLayer @boundaryLayer


    destroy: () ->
        @_destroyed = true
        if @_post? then @_post.abort()

        @parent.topBuffer = () ->
            return 0

        App.map.options.maxZoom = @oldMaxZoom

        App.map.off 'zoomend', @updateBoundaries
        App.layer_store.empty()


        super()
